/**
 * Maximum allowed pattern length to prevent overly complex expressions.
 */
const MAX_PATTERN_LENGTH = 500

/**
 * Detects common ReDoS-prone constructs (nested quantifiers).
 * Catches patterns like (a+)+, (a*)+, (a+)*, (a{2,})+ etc.
 */
const NESTED_QUANTIFIER_REGULAR_EXPRESSION = /([+*}])\s*\)\s*[+*?{]/

/**
 * Compile a regular expression from an untrusted pattern string safely.
 * Returns null when the pattern is empty, syntactically invalid, too long,
 * or contains constructs prone to catastrophic backtracking (ReDoS).
 */
export function safeRegExp(
  pattern: string | null | undefined,
  flags?: string,
): RegExp | null {
  if (
    !pattern ||
    pattern.length > MAX_PATTERN_LENGTH ||
    NESTED_QUANTIFIER_REGULAR_EXPRESSION.test(pattern)
  ) {
    return null
  }

  try {
    return new RegExp(pattern, flags)
  } catch {
    return null
  }
}
